<template>
  <!-- <div style="width: inherit;"> -->
  <div class="actionsDisplay">
    <btnNovaNota
      v-if="component.name === 'NFSE' && component.tipo === 'emitida'  && empresa.servicos && empresa.servicos.robotizacao && empresa.servicos.robotizacao.find(item => item.nomeServico === 'NFSE_TOMADOS')"
      :conta="conta"
      :empresa="empresa"
      :table="table"
      :component="component"
      :edit="true"
      :nota="this.nota.item"
    ></btnNovaNota>
    <btnNovoImovel v-if="component.name =='automacaoFiscal'" :IBGE="this.IBGE" :edit="true" :nota="this.nota.item" :empresa="empresa"></btnNovoImovel>
    <btnInfNfses
      style="display: inline-grid;"
      :nota="this.nota.item"
      :table="this.table"
      :component="this.component"
      v-if="component.name =='NFSE'"
    ></btnInfNfses>
    <btnVisualizar
      :component="this.component"
      :nota="this.nota"
      v-if="this.component.enable.verPdf"
    ></btnVisualizar>
    <btnManifestar
      v-if="(this.component.name.indexOf('NFeRecebidas') != -1 && this.component.tipo != 'emitida' && this.component.tipo != 'transportados' || this.component.name.indexOf('CTE') != -1  && this.component.tipo == 'tomados') && this.empresa.cnpj.length > 11"
      :chave="this.nota.item.chave"
      :empresa="empresa._id"
      :component="this.component"
      :nota="this.nota"
    ></btnManifestar>
    <btnDownload
      @click.native="getPDFXml(nota.item._id, 2)"
      :component="this.component"
      :nota="this.nota"
    ></btnDownload>
    <btnXml
    v-if="component.name === 'NFSE' && empresa.servicos && empresa.servicos.robotizacao && empresa.servicos.robotizacao.find(item => item.nomeServico === 'NFSE_TOMADOS')"
    :conta="conta"
    :empresa="empresa"
    :nota="this.nota"
    :component="component"
    ></btnXml>
    <btnEmail
      style="display: inline-block;"
      :empresa="this.empresa"
      :id_nota="this.nota.item._id"
      :conta="this.conta"
      :table="this.table"
      :component="this.component"
      v-if="this.component.enable.envEmail"
    ></btnEmail>
    <btnInfClientFornc
      style="display: inline-block;"
      :forn="this.nota.item"
      :table="this.table"
      :component="this.component"
      v-if="component.name =='fornecedores' || component.name == 'clientes'"
    ></btnInfClientFornc>
    <rmvCertificado
      :attTableEmp="this.attTableEmp"
      @attTableEmp="attTableEmp($event)"
      :empresa="this.empresa"
      :table="this.table"
      :alert="this.alert"
      :nota="nota"
      :conta="this.conta"
      v-if="component.name =='certificado'"
    ></rmvCertificado>
    <v-tooltip v-if="component.name =='empresa'" bottom>
      <v-btn slot="activator" dark icon small flat @click.native="emitEditEmp()">
        <v-icon class="material-icons">edit</v-icon>
      </v-btn>
      <span>Alterar informações desta empresa</span>
    </v-tooltip>
    <btnUserEmpresa
      :table="this.table"
      :alert="this.alert"
      :nota="nota"
      :conta="this.conta"
      v-if="component.name =='empresa'"
    ></btnUserEmpresa>
    <btnLinkIntegracao
      :table="this.table"
      :alert="this.alert"
      :nota="nota"
      :conta="this.conta"
      v-if="component.name =='empresa'"
    ></btnLinkIntegracao>
    <rmvColaborador
      :attTableEmp="this.attTableEmp"
      @attTableEmp="attTableEmp($event)"
      :empresa="this.empresa"
      :table="this.table"
      :alert="this.alert"
      :nota="nota"
      :conta="this.conta"
      v-if="component.name =='usuario'"
    ></rmvColaborador>
    <reenvioEmail
      :attTableEmp="this.attTableEmp"
      @attTableEmp="attTableEmp($event)"
      :empresa="this.empresa"
      :nota="this.nota.item"
      :conta="this.conta"
      v-if="component.name =='usuario' && (nota.item.preCadastro != undefined && nota.item.preCadastro.length > 0)"
    />
  </div>
</template>
<script>
import btnDownload from "./btnDownload/BtnDownload.vue";
import btnVisualizar from "./btnVisualizar/BtnVisualizar.vue";
import btnManifestar from "./btnManifestar/BtnManifestar.vue";
import btnEmail from "./btnEmail/BtnEmail.vue";
import btnUserEmpresa from "./btnUserEmpresa/BtnUserEmpresa.vue";
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
import btnInfClientFornc from "./btnInfClientFornc/BtnInfClientFornc";
import btnInfNfses from "./btnInfNfses/btnInfNfses.vue";
import rmvCertificado from "./rmvCertificado/RmvCertificado.vue";
import rmvColaborador from "./rmvColaborador/RmvColaborador.vue";
import btnLinkIntegracao from "./btnLinkIntegracao/LinkIntegracao.vue";
import reenvioEmail from "./reenvioEmail/ReenvioEmail.vue";
import btnNovaNota from "@/components/dataTable/commonTable/actionsHeader/btnNovaNota/BtnNovaNota.vue";
import btnNovoImovel from '@/pages/loggedArea/configuracoes/configuracoesAutomacao/BtnNovoImovel/BtnNovoImovel.vue';
import btnXml from "../../commonTable/coluna_actions/btnDownload/btnXml/BtnXml.vue";
export default {
  props: ["conta", "alert", "nota", "empresa", "component", "table", "IBGE"],
  beforeMount() {},
  data: () => ({
    openDialog: false
  }),
  components: {
    btnDownload: btnDownload,
    btnVisualizar: btnVisualizar,
    btnManifestar: btnManifestar,
    btnEmail: btnEmail,
    btnInfClientFornc: btnInfClientFornc,
    btnInfNfses: btnInfNfses,
    btnUserEmpresa: btnUserEmpresa,
    rmvColaborador: rmvColaborador,
    rmvCertificado: rmvCertificado,
    btnLinkIntegracao: btnLinkIntegracao,
    reenvioEmail: reenvioEmail,
    btnNovaNota,
    btnNovoImovel,
    btnXml
  },
  computed: {},
  methods: {
    attTableEmp(value) {
      this.$emit("attTableEmp", value);
    },
    emitEditEmp() {
      this.$emit("emitEditEmp", this.nota.item);
    },
    getPDFXml: function(id, option) {
      if (this.component.name.indexOf("NFe") != -1) {
        this.service = new NfeService(this.$http);
      } else {
        this.service = new CteService(this.$http);
      }
      return;
      switch (option) {
        case 1:
          this.getPDF(id);
          break;
        case 2:
          this.getPDF(id);
          this.getXml(id);
          break;
      }
    },
    getPDF: function(id) {
      if (!this.nota.item.danfe) {
        if (this.component.name.indexOf("NFe") != -1) {
          this.service
            .getDanfe(id)
            .then(danfe => (this.nota.item.danfe = danfe));
        } else {
          this.service
            .getDacte(id)
            .then(danfe => (this.nota.item.danfe = danfe));
        }
      }
    },
    getXml: function(id) {
      if (!this.nota.item.xml) {
        this.service.getXml(id).then(xml => (this.nota.item.xml = xml));
      }
    }
  }
};
</script>
<style scoped>
.R_icon {
  margin-left: -8px;
  margin-right: -8px;
}
.actionsDisplay {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: -2px;
}
</style>




// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/ColumnActions.vue